import "./Carousel.css";

const Carousel = (props) => {
  return (
    <>
      <div className="carousel-container">
        <div className="carousel">
          <img
            src={require("./Assets/itlandschap.png")}
            alt="IT-landschap app"
            onClick={() => props.onClick("itlandschap")}
          ></img>
          <img
            src={require("./Assets/Budget.png")}
            alt="Budget app"
            onClick={() => props.onClick("budget")}
          ></img>
          <img
            src={require("./Assets/Atomss.png")}
            alt="ety-app"
            onClick={() => props.onClick("atoms")}
          ></img>
          <img
            src={require("./Assets/Quiz.png")}
            alt="Quiz app"
            onClick={() => props.onClick("quiz")}
          ></img>
          <img
            src={require("./Assets/EtyAPP.png")}
            alt="ety-app"
            onClick={() => props.onClick("ety")}
          ></img>
        </div>
      </div>
    </>
  );
};

export default Carousel;
